import React from "react";
import { FaAward, FaCalendarCheck, FaUsers, FaChartColumn } from "react-icons/fa6";

// Fill these in to show the "learners across cohorts" point; it stays hidden until both are set.
const LEARNERS = 400;
const COHORTS = 2;

const POINTS = [
  {
    icon: FaAward,
    title: "Accredited, not improvised.",
    body: "E1X is accredited by the American Council of Training and Development across AI and software development, data science, digital and professional skills, and technology and programming.",
  },
  {
    icon: FaCalendarCheck,
    title: "Thirteen weeks, not a workshop.",
    body: "Twelve weeks of live instruction plus a capstone week. Real projects against real industry briefs. Every class is recorded, so nobody misses a class.",
  },
  LEARNERS && COHORTS
    ? {
        icon: FaUsers,
        title: `${LEARNERS} learners across ${COHORTS} cohorts.`,
        body: null,
      }
    : null,
  {
    icon: FaChartColumn,
    title: "Reporting as standard.",
    body: "Every sponsor receives enrollment, attendance and completion data.",
  },
].filter(Boolean);

export default function SponsorBacking() {
  return (
    <section className="bg-[#0b0f19] py-24 text-white">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-[11px] font-bold tracking-[0.15em] uppercase text-gray-400 mb-6 flex items-center gap-3">
          <span className="block w-8 h-[2px] bg-primary" />
          Why E1X
        </div>
        <h2 className="text-3xl md:text-5xl font-bold max-w-2xl">
          What your funding is backing<span className="text-primary">.</span>
        </h2>

        <div className="mt-10 md:mt-14 grid gap-6 md:grid-cols-2">
          {POINTS.map(({ icon: Icon, title, body }) => (
            <div key={title} className="flex gap-4 rounded-[10px] bg-white/5 border border-white/10 p-6 md:p-8">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary text-white">
                <Icon size={20} />
              </span>
              <div>
                <h3 className="text-lg font-bold">{title}</h3>
                {body && <p className="mt-2 text-gray-300 leading-relaxed">{body}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
